import React from 'react';
import { Redirect, useParams } from 'react-router';
import { CreateAutomation } from 'components/organisms/module-settings/integrations/integrations-list/salesforce/automation/create/create';
import { RoutePaths } from 'constant';

export const AutomationsCreatePage = () => {
  const { integrationId } = useParams<{ integrationId: string }>();

  if (Number.isNaN(Number(integrationId))) {
    return <Redirect push to={`${RoutePaths.salesforceIntegrations}`} />;
  }

  return <CreateAutomation integrationId={Number(integrationId)} />;
};
